import { IconProps } from "@models/types";

export function CartIcon({ className, height, width }: IconProps) {
  return (
    <>
      <svg
        className={className}
        width={width}
        height={height}
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <g id="Path_140" data-name="Path 140">
          <path d="M3.46,5.63,1.32,18.84H18.68L16.54,5.63H3.46m-.83-1H17.37L19.82,19.8H.18Z" />
        </g>
        <path d="M5.32,7.49H5.27A.49.49,0,0,1,4.82,7c0-.28.62-6.75,5.23-6.75S15.27,6.67,15.29,7a.5.5,0,1,1-1,.08c0-.06-.52-5.83-4.24-5.83S5.82,7,5.81,7A.5.5,0,0,1,5.32,7.49Z" />
      </svg>
    </>
  );
}
